// extracted by mini-css-extract-plugin
module.exports = {"shippingOptions":"shippingMethodForm-module__shippingOptions___c+ZTy","nextButton":"shippingMethodForm-module__nextButton___MC59x"};